import React, { useEffect } from "react";
import { useQuery } from "../../../../hooks/useQuery";
import AssociationResume from "./AssociationResume";
import { CardHeader } from "@mui/material";

const DashboardPage = () => {
  const query = useQuery();
  useEffect(() => {
    if (query.get("ref")) localStorage.setItem("TOKEN_ADM", query.get("ref"));
  }, [query.get("ref")]);
  return (
    <>
      <CardHeader
        title="Tableau de bord"
        titleTypographyProps={{ variant: "h5" }}
      />
      <AssociationResume />
    </>
  );
};

export default DashboardPage;
